import React from 'react';

import { DiscoveryScreen } from './DiscoveryScreen';

export function DiscoveryTab() {
  return <DiscoveryScreen />;
}
